import authentication from '../middleware/authentication'
const TwilioSetting = () => import(/* webpackChunkName: "static/js/chunks/TwilioSetting" */'../../views/twilioSetting/TwilioSetting')
const TwilioSetup = () => import(/* webpackChunkName: "static/js/chunks/TwilioSetup" */'../../views/twilioSetting/TwilioSetup')

const twilioSettingRoutes = [
  {
    path: '/twilio-setup',
    name: 'TwilioSetup',
    component: TwilioSetup,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  },
  {
    path: '/twilio-setting',
    name: 'TwilioSetting',
    component: TwilioSetting,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  }
]

export default twilioSettingRoutes
